module.exports = __webpack_public_path__ + "static/media/Mexican.72195a15.jpg";